import styled from '@emotion/styled';
import { ReactNode } from 'react';
import { Radio } from 'semantic-ui-react';

type Props<T extends string | number | undefined> = {
  selected: T;
  value: T;
  onSelect: (value: T) => void;
  className?: string;
  children: ReactNode;
};

export const RadioButton = <T extends string | number | undefined>({
  selected,
  value,
  onSelect,
  children,
  className,
  ...props
}: Props<T>) => {
  return (
    <Radio
      className={className}
      value={value}
      checked={selected === value}
      onChange={(_e, { value }) => onSelect(value as T)}
      label={<S.Label>{children}</S.Label>}
      {...props}
    />
  );
};

const S = {
  Label: styled.div`
    border: 1px solid #e2e2e3;
    background-color: #fff;
    cursor: pointer;
    padding: 6px 8px;
    width: 100%;
    border-radius: 15px;
    white-space: nowrap;
    .ui.radio.checkbox.checked > & {
      background-color: #dfe0e0;
      &:hover {
        background-color: #c1c1c1;
      }
    }
    &:hover {
      background-color: #c9cacc;
    }
  `,
};
